<navigation [forceTitle]="'Subscription.notfound.Name' | translate"></navigation>
<div class="wrapper">
  <not-found />
  <div class="container"><footer></footer></div>
</div>
